"use strict";
exports.__esModule = true;
var angular = require("angular");
var COMPONENT_NAME = 'smartorg.r6.navs.recalcRecords';
var ALERT_TYPE = {
    success: 'success',
    danger: 'danger',
    warning: 'warning'
};
function toHHMMSS(sec_num) {
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);
    var hs = hours < 10 ? "0" + hours : hours;
    var ms = minutes < 10 ? "0" + minutes : minutes;
    var ss = seconds < 10 ? "0" + seconds : seconds;
    return hs + ":" + ms + ":" + ss;
}
function getDuration(startTime, endTime) {
    return toHHMMSS(Math.floor((endTime - startTime) / 1000));
}
var RecalcRecordsComponent = /** @class */ (function () {
    function RecalcRecordsComponent($timeout) {
        this.$timeout = $timeout;
    }
    RecalcRecordsComponent.prototype.$onChanges = function () {
        this.showRecalcRecord();
    };
    RecalcRecordsComponent.prototype.showAlert = function (type, title, message) {
        this.showAlertService({ input: { type: type, title: title, message: message } });
    };
    RecalcRecordsComponent.prototype.showRecalcRecord = function () {
        var _this = this;
        var ctrl = this;
        this.loading = true;
        this.smartorgApi.getRecalculateRecord(this.treeObj.treeName).then(function (response) {
            console.log(response);
            ctrl.generateGridOptions(response);
            _this.loading = false;
            ctrl.$timeout();
        })["catch"](function (err) {
            _this.loading = false;
            ctrl.showAlert(ALERT_TYPE.danger, "Server Error " + err.status, "Failed to load recalculate records. " + err.message);
            ctrl.$timeout();
        });
    };
    RecalcRecordsComponent.prototype.generateGridOptions = function (records) {
        var ctrl = this;
        var failedCountCellTemplate = "<div\n          class=\"ui-grid-cell-contents\"\n          title=\"TOOLTIP\">\n          {{COL_FIELD CUSTOM_FILTERS}}\n          <button ng-if=\"row.entity.showRecalc\" \n            class=\"btn btn-primary btn-xs pull-right\"\n            ng-click=\"grid.appScope.$ctrl.recalcNodes(row.entity)\">\n            <i ng-if=\"row.entity.calcing\" class=\"fa fa-spinner fa-spin\"></i>\n            <span ng-if=\"!row.entity.calcing\">Recalculate</span>\n          </button>\n        </div>";
        var columnDefs = [
            { name: 'startNode', width: '150', cellTooltip: function (row) { return row.entity.startNode; } },
            { name: 'numberOfLeaves', width: '150' },
            { name: 'status', width: '200', cellTemplate: failedCountCellTemplate },
            { name: 'startedOn', width: '150' },
            { name: 'duration', width: '100' },
            { name: 'admin', width: '100' },
        ];
        var data = [];
        records.forEach(function (r) {
            var _id = r._id, portfolio = r.portfolio, series = r.series;
            var lastIndex = series.length - 1;
            series.forEach(function (s, index) {
                var startNode = s.startNode, numberOfNodes = s.numberOfNodes, successCount = s.successCount, startTime = s.startTime, endTime = s.endTime, username = s.username;
                var sn = startNode ? ctrl.treeObj.nodeMap[startNode] : ctrl.treeObj.treeData;
                var failedNodes = s.failedNodes || [];
                var status = 'Pending';
                if (endTime) {
                    status = !failedNodes || failedNodes.length === 0 ? 'Success' : "Fail (" + failedNodes.length + ")";
                }
                var numberOfLeaves = numberOfNodes;
                if (typeof successCount !== 'undefined') {
                    numberOfLeaves = successCount + (failedNodes ? failedNodes.length : 0);
                }
                var breadcrumb = sn ? sn.getBreadcrumb() : 'Deleted Node';
                data.push({
                    startNode: index === 0 ? breadcrumb : '',
                    numberOfLeaves: numberOfLeaves,
                    status: status,
                    startedOn: startTime.split('.')[0],
                    duration: endTime ? getDuration(new Date(startTime), new Date(endTime)) : '-',
                    admin: username,
                    seriesId: _id,
                    portfolio: portfolio,
                    failedNodes: failedNodes,
                    failedCount: failedNodes.length,
                    showRecalc: failedNodes.length && index === lastIndex,
                    $$treeLevel: index === 0 ? 0 : 1
                });
            });
        });
        ctrl.gridOptions = {
            enableSorting: false,
            enableFiltering: false,
            showTreeExpandNoChildren: false,
            columnDefs: columnDefs,
            data: data
        };
    };
    RecalcRecordsComponent.prototype.recalcNodes = function (rowEntity) {
        var seriesId = rowEntity.seriesId, portfolio = rowEntity.portfolio, failedNodes = rowEntity.failedNodes;
        if (!failedNodes.length) {
            return;
        }
        rowEntity.calcing = true;
        var nodeIds = failedNodes.map(function (n) { return n._id; });
        var ctrl = this;
        this.smartorgApi.recalculateNodes(portfolio, nodeIds, seriesId).then(function (response) {
            ctrl.showRecalcRecord();
        })["catch"](function (err) {
            ctrl.showAlert(ALERT_TYPE.danger, "Server Error " + err.status, "Failed to recalculate. " + err.message);
        });
    };
    return RecalcRecordsComponent;
}());
angular.module(COMPONENT_NAME, [
    'ui.grid',
    'ui.grid.treeView',
    'ui.grid.resizeColumns',
]).component('recalcRecords', {
    template: require('./recalc-records.component.html'),
    bindings: {
        smartorgApi: '=',
        showAlertService: '&',
        treeObj: '<'
    },
    controller: RecalcRecordsComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=recalc-records.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/recalc/records/recalc-records.component.js